import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";

import { GenericDrawerService } from "./global-drawer.service";

@Component({
    selector: "ch-drawer",
    templateUrl: "./drawer.component.html",
    styleUrls: ["./drawer.component.scss"],
    standalone: true,
})
export class DrawerComponent implements OnInit, AfterViewInit {
  @Input() showDrawer: boolean = false;
  componentInstance: ComponentRef<any>;

  @ViewChild("viewContainerRef", { read: ViewContainerRef })
  public drawerComponentRef: ViewContainerRef;

  constructor(
    public genericDrawerService: GenericDrawerService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.genericDrawerService.closeDrawer$.subscribe(() => {
      this.closeDrawer();
    });
  }

  ngOnDestroy() {
    if (this.componentInstance) {
      this.componentInstance.destroy();
    }
  }

  buildComponent() {
    this.drawerComponentRef.clear();

    this.componentInstance = this.drawerComponentRef.createComponent(
      this.genericDrawerService.component
    );

    Object.keys(this.genericDrawerService.data).forEach((key) => {
      this.componentInstance.setInput(key, this.genericDrawerService.data[key]);
    });

    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    this.buildComponent();
  }

  closeDrawer() {
    this.drawerComponentRef.remove();
    this.drawerComponentRef.clear();
    this.componentInstance.destroy();

    this.genericDrawerService.showDrawer = false;
  }
}
